export default __webpack_public_path__ + "static/media/bestPractice.5a8d0f8b.svg";